var _path, _path2, _path3, _linearGradient;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeather(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 441 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    id: "weather",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273.795,268.526V53.235C273.795,23.881,249.913,0,220.559,0s-53.235,23.881-53.235,53.235V268.53 c-26.609,18.183-42.311,48.963-41.218,81.341c1.636,48.542,40.887,88.564,89.358,91.115c1.726,0.091,3.446,0.136,5.159,0.136 c24.326,0,47.231-9.105,64.975-25.94c19.005-18.031,29.471-42.383,29.471-68.57C315.068,315.067,299.72,286.185,273.795,268.526z  M275.274,404.299c-15.977,15.16-36.937,22.875-59.021,21.707c-40.766-2.145-73.778-35.81-75.155-76.641 c-0.959-28.436,13.478-55.409,37.676-70.394c2.208-1.367,3.551-3.779,3.551-6.376V53.235C182.324,32.152,199.477,15,220.56,15 s38.235,17.152,38.235,38.235v219.359c0,2.597,1.344,5.009,3.552,6.376c23.62,14.627,37.722,39.913,37.722,67.64 C300.068,368.642,291.263,389.129,275.274,404.299z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.816,325.48c-1.253-3.948-5.469-6.134-9.417-4.881c-3.948,1.252-6.134,5.468-4.882,9.417 c1.693,5.338,2.552,10.921,2.552,16.595c0,14.561-5.67,28.25-15.965,38.545c-10.992,10.994-25.842,16.717-41.539,15.884 c-27.925-1.469-50.539-24.538-51.482-52.518c-0.658-19.509,9.248-38.015,25.851-48.296l11.838-7.331 c2.208-1.367,3.552-3.779,3.552-6.376V65h26.471v221.519c0,2.597,1.344,5.009,3.551,6.376l11.838,7.331 c3.523,2.181,8.145,1.094,10.325-2.428c2.182-3.521,1.095-8.144-2.427-10.325l-8.287-5.132V57.5c0-4.142-3.357-7.5-7.5-7.5 h-41.471c-4.142,0-7.5,3.358-7.5,7.5v224.842l-8.287,5.131c-21.16,13.103-33.784,36.689-32.945,61.554 c1.203,35.691,30.056,65.118,65.687,66.992c1.26,0.066,2.533,0.1,3.787,0.1c18.565,0,36.02-7.229,49.146-20.357 c13.128-13.129,20.357-30.585,20.357-49.152C290.068,339.396,288.974,332.287,286.816,325.48z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.053,315.409c1.987,0,3.88-0.813,5.3-2.19c2.757-2.841,2.924-7.38,0.251-10.342 c-2.308-2.558-6.214-3.187-9.219-1.506c-3.023,1.692-4.508,5.362-3.517,8.682C262.808,313.201,265.762,315.409,269.053,315.409z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#gradient)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: 87.9999,
    y1: 0,
    x2: 87.9999,
    y2: 441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.7dbce9d2bd70e3f9c8d297e4d288024f.svg";
export { ForwardRef as ReactComponent };